import revive_payload_client_4sVQNw7RlN from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/alexandarvalov/Documents/GitHub/Milab/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/Users/alexandarvalov/Documents/GitHub/Milab/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import vue_circle_flags_gVonAul4aF from "/Users/alexandarvalov/Documents/GitHub/Milab/plugins/vue-circle-flags.ts";
import vuetify_7h9QAQEssH from "/Users/alexandarvalov/Documents/GitHub/Milab/plugins/vuetify.ts";
import ssg_detect_3fHkBxLtv0 from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  vue_circle_flags_gVonAul4aF,
  vuetify_7h9QAQEssH,
  ssg_detect_3fHkBxLtv0
]